export default __webpack_public_path__ + "static/media/Android.07ff01ec.png";